import { productInformationStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import { css } from "styled-components";

productInformationStyles.partNumbersGridItem = {
    width: 12,
    css: css`
        span {
            font-size: 14px;
        }
    `,
};

productInformationStyles.container = {
    gap: 10,
    css: css`
        width: 100%;
        background: #f8f8f8;
        padding: 14px 14px 0px 14px;
    `,
};
